import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { ButtonGroup, Button, Row, Col } from 'reactstrap';
import { Utils } from '../../../../services';
import { Loader, AccountingPieChart } from '../../../../components';
import { loadCashregisters, loadSalepoints } from '../../../../redux';
import moment from 'moment';
import _ from 'lodash';

import './Revenue.css';

const Revenue = () => {
    const { t, i18n } = useTranslation();
    const dispatch    = useDispatch();

    const me = useSelector(state => state.auth.user);

    const { loadingErrorMessage, cashregisters } = useSelector(state => state.cashregisters);
    const { salepoints } = useSelector(state => state.salepoints);

    const filters = {
        from: moment().startOf('day').toISOString(),
        to: moment().endOf('day').toISOString(),
    };

    useEffect(() => {
        dispatch(loadCashregisters());
        dispatch(loadSalepoints());
    }, [dispatch]);

    const name = _id => {
        const cashregister = cashregisters?.find(c => c._id === _id);
        if (!cashregister)
            return null;

        const salepoint = salepoints?.find(s => s._id === cashregister.salepoint_id);
        if (!salepoint)
            return null;

        return `${Utils.localized_or_fallback(salepoint.name, i18n.language)} - ${Utils.localized_or_fallback(cashregister.name, i18n.language)}`;
    };

    if (!cashregisters || !salepoints)
        return <Loader />;

    return (
        <div className='Revenue'>
            <Row className="flex-1">
                <Col>
                    <div className='h-10 border-bottom'>
                        <h5>{ t('dashboard.revenue.title') }</h5>
                    </div>

                    {loadingErrorMessage && (
                        <h6 className="mt-2 text-italic text-danger">
                            { loadingErrorMessage }
                        </h6>
                    )}

                    {!loadingErrorMessage && (
                        <div className="chart">
                            <AccountingPieChart
                                hideTitle
                                hideDetails
                                showBigNumber
                                transparentBackground
                                group_by="cashregister"
                                icon="fa-th"
                                filters={ filters }
                                currency={Utils.currency()}
                                colorScheme="pastel1"
                                chartDataBuilder={ result => ({
                                    _id: result.cashregister,
                                    id: name(result.cashregister),
                                    label: name(result.cashregister),
                                    value: result.total_amount,
                                    data: { count: parseInt(result.count, 10) }
                                })}
                            />
                        </div>
                    )}
                    <div className="text-right">
                        <Button tag={Link} to="/stats/accounting" className="btn btn-info">
                            <i className="fa fa-money" />&nbsp;
                            { t('dashboard.revenue.go_to_stats') }
                        </Button>
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default Revenue;
